export default "__VITE_ASSET__BU5u0J1H__"